// @flow
import * as React from "react";

import AuthService from "services/auth";

import { Navigate, Outlet } from "react-router-dom";

function GuestRoute(): React.Node {
  if (AuthService.isAuthenticated()) {
    return <Navigate replace to="/" />;
  }

  return <Outlet />;
}

export default GuestRoute;
